/* Gear & Gown Shopify theme interactions */

function initMobileNavigation() {
  const menu = document.querySelector('[data-mobile-nav]');
  const open = document.querySelector('[data-open-menu]');
  const close = document.querySelector('[data-close-menu]');
  if (!menu) return;
  const closeMenu = () => {
    menu.classList.remove('open');
    menu.setAttribute('aria-hidden', 'true');
    open?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    open?.focus();
  };
  open?.addEventListener('click', () => {
    menu.classList.add('open');
    menu.setAttribute('aria-hidden', 'false');
    open.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    close?.focus();
  });
  close?.addEventListener('click', closeMenu);
  menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && menu.classList.contains('open')) closeMenu(); });
}

function initEmbroideryRequests() {
  document.querySelectorAll('[data-embroidery-request]').forEach((request) => {
    const toggle = request.querySelector('[data-embroidery-toggle]');
    const fields = request.querySelector('[data-embroidery-fields]');
    const name = request.querySelector('[data-embroidery-name]');
    const placement = request.querySelector('[data-embroidery-placement]');
    const notes = request.querySelector('[data-embroidery-notes]');
    const link = request.querySelector('[data-embroidery-whatsapp]');
    const paymentNotice = request.querySelector('[data-embroidery-payment-notice]');
    const consent = request.querySelector('[data-embroidery-consent]');
    const consentError = request.querySelector('[data-embroidery-consent-error]');
    if (!toggle || !fields) return;
    const submittedFields = Array.from(fields.querySelectorAll('[name]'));

    const update = () => {
      fields.hidden = !toggle.checked;
      submittedFields.forEach((field) => { field.disabled = !toggle.checked; });
      if (paymentNotice) paymentNotice.hidden = !toggle.checked;
      if (consent) {
        consent.disabled = !toggle.checked;
        consent.required = toggle.checked;
        if (!toggle.checked) consent.checked = false;
      }
      if (consentError) consentError.hidden = true;
      if (link) {
        const lines = [
          'Hi Gear & Gown. I would like custom embroidery on ' + request.dataset.productName + '.',
          name?.value.trim() ? 'Embroidery text: ' + name.value.trim() : '',
          placement?.value ? 'Placement: ' + placement.value : '',
          notes?.value.trim() ? 'Notes: ' + notes.value.trim() : ''
        ].filter(Boolean);
        link.href = 'https://wa.me/923159184918?text=' + encodeURIComponent(lines.join('\n'));
      }
    };

    toggle.addEventListener('change', update);
    consent?.addEventListener('change', () => { if (consentError) consentError.hidden = true; });
    [name, placement, notes].filter(Boolean).forEach((field) => field.addEventListener('input', update));
    update();
  });
}

function initProductEmbroidery() {
  document.querySelectorAll('[data-product-embroidery]').forEach((request) => {
    const toggle = request.querySelector('[data-product-embroidery-toggle]');
    const fields = request.querySelector('[data-product-embroidery-fields]');
    const paymentNotice = request.querySelector('[data-embroidery-payment-notice]');
    const consent = request.querySelector('[data-embroidery-consent]');
    const consentError = request.querySelector('[data-embroidery-consent-error]');
    if (!toggle || !fields) return;
    const update = () => {
      fields.hidden = !toggle.checked;
      fields.querySelectorAll('input, select, textarea').forEach((field) => { field.disabled = !toggle.checked; });
      if (paymentNotice) paymentNotice.hidden = !toggle.checked;
      if (consent) {
        consent.disabled = !toggle.checked;
        consent.required = toggle.checked;
        if (!toggle.checked) consent.checked = false;
      }
      if (consentError) consentError.hidden = true;
    };
    toggle.addEventListener('change', update);
    consent?.addEventListener('change', () => { if (consentError) consentError.hidden = true; });
    update();
  });
}

function initCartQuantityControls() {
  document.querySelectorAll('[data-cart-quantity-control]').forEach((control) => {
    const input = control.querySelector('[data-cart-quantity]');
    const minus = control.querySelector('[data-cart-quantity-minus]');
    const plus = control.querySelector('[data-cart-quantity-plus]');
    if (!input || !minus || !plus) return;
    const change = (amount) => {
      const current = Number.parseInt(input.value, 10) || 0;
      input.value = Math.max(0, current + amount);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    minus.addEventListener('click', () => change(-1));
    plus.addEventListener('click', () => change(1));
  });
}

function initBundleBuilder() {
  document.querySelectorAll('[data-bundle-builder]').forEach((builder) => {
    const modeButtons = Array.from(builder.querySelectorAll('[data-bundle-mode-button]'));
    const panels = Array.from(builder.querySelectorAll('[data-bundle-mode-panel]'));
    const addButton = builder.querySelector('[data-bundle-add]');
    const status = builder.querySelector('[data-bundle-status]');
    if (!modeButtons.length || !panels.length || !addButton) return;

    let activeMode = modeButtons.find((button) => button.classList.contains('is-active'))?.dataset.bundleModeButton || 'duo';
    const modeLabel = { duo: 'Rotation Duo', trio: 'Full Rotation', layered: 'Layered Set' };

    const showMode = (mode) => {
      activeMode = mode;
      modeButtons.forEach((button) => {
        const active = button.dataset.bundleModeButton === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const active = panel.dataset.bundleModePanel === mode;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      if (status) status.textContent = '';
    };

    modeButtons.forEach((button) => button.addEventListener('click', () => showMode(button.dataset.bundleModeButton)));
    document.querySelectorAll('[data-bundle-jump]').forEach((button) => button.addEventListener('click', () => {
      showMode(button.dataset.bundleJump);
      builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    addButton.addEventListener('click', async () => {
      const panel = panels.find((item) => item.dataset.bundleModePanel === activeMode);
      const selects = Array.from(panel?.querySelectorAll('[data-bundle-item]') || []);
      const selected = selects.map((select) => select.options[select.selectedIndex]);
      if (!selected.length || selected.some((option) => !option?.value)) {
        if (status) status.textContent = 'Choose every product, size and colour first.';
        return;
      }

      const originalText = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = 'Adding';
      if (status) status.textContent = '';
      try {
        const items = selected.map((option) => ({
          id: Number(option.value),
          quantity: 1,
          properties: { Bundle: modeLabel[activeMode] || 'Gear & Gown bundle' },
        }));
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) throw new Error('Unable to add bundle');
        window.location.href = '/cart';
      } catch (error) {
        if (status) status.textContent = 'Could not add the bundle. Please try again.';
        addButton.disabled = false;
        addButton.textContent = originalText;
      }
    });

    showMode(activeMode);
  });
}

function initProductCarousels() {
  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-product-slide]'));
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const current = carousel.querySelector('[data-carousel-current]');
    const total = carousel.querySelector('[data-carousel-total]');
    const story = carousel.closest('[data-story-product]');
    const colorButtons = Array.from(story?.querySelectorAll('[data-story-color]') || []);
    const hasColorSlides = slides.some((slide) => slide.dataset.storyGalleryColor);
    let visibleSlides = slides;
    let index = 0;
    const zoomButton = carousel.querySelector('[data-gallery-zoom]');
    const zoomViewer = carousel.closest('[data-story-product]')?.querySelector('[data-product-zoom]');
    const zoomFrame = zoomViewer?.querySelector('.product-zoom-frame');
    const zoomImage = zoomViewer?.querySelector('[data-product-zoom-image]');
    let panState = null;
    let suppressZoomClick = false;

    if (!slides.length) return;

    const matchingSlides = (color) => {
      if (!hasColorSlides || !color) return slides;
      const matches = slides.filter((slide) => slide.dataset.storyGalleryColor === color);
      return matches.length ? matches : slides;
    };

    const show = (nextIndex) => {
      index = (nextIndex + visibleSlides.length) % visibleSlides.length;
      slides.forEach((slide) => {
        const active = slide === visibleSlides[index];
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });
      if (current) current.textContent = String(index + 1).padStart(2, '0');
      if (total) total.textContent = String(visibleSlides.length).padStart(2, '0');
    };

    const showColor = (color) => {
      visibleSlides = matchingSlides(color);
      show(0);
    };

    const resetZoomScroll = () => {
      if (!zoomFrame) return;
      zoomFrame.scrollLeft = 0;
      zoomFrame.scrollTop = 0;
    };

    const closeZoom = () => {
      if (!zoomViewer) return;
      zoomViewer.hidden = true;
      zoomViewer.setAttribute('aria-hidden', 'true');
      zoomFrame?.classList.remove('is-zoomed');
      zoomImage?.classList.remove('is-zoomed');
      zoomFrame?.classList.remove('is-panning');
      panState = null;
      resetZoomScroll();
      document.body.classList.remove('product-zoom-open');
      zoomButton?.focus();
    };
    const openZoom = () => {
      const image = visibleSlides[index]?.querySelector('img');
      if (!zoomViewer || !zoomImage || !image) return;
      zoomImage.src = image.currentSrc || image.src;
      zoomImage.alt = image.alt || 'Product image preview';
      zoomFrame?.classList.remove('is-zoomed');
      zoomImage.classList.remove('is-zoomed');
      zoomFrame?.classList.remove('is-panning');
      resetZoomScroll();
      zoomViewer.hidden = false;
      zoomViewer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('product-zoom-open');
      zoomViewer.querySelector('.product-zoom-close')?.focus();
    };

    zoomButton?.addEventListener('click', openZoom);
    zoomImage?.addEventListener('click', (event) => {
      if (suppressZoomClick) {
        suppressZoomClick = false;
        event.preventDefault();
        return;
      }
      const zoomed = !zoomImage.classList.contains('is-zoomed');
      zoomImage.classList.toggle('is-zoomed', zoomed);
      zoomFrame?.classList.toggle('is-zoomed', zoomed);
      if (!zoomed) resetZoomScroll();
    });
    const startPan = (clientX, clientY) => {
      if (!zoomImage?.classList.contains('is-zoomed')) return;
      panState = {
        startX: clientX,
        startY: clientY,
        startLeft: zoomFrame.scrollLeft,
        startTop: zoomFrame.scrollTop,
        moved: false,
      };
      zoomFrame.classList.add('is-panning');
    };
    const movePan = (clientX, clientY, event) => {
      if (!panState) return;
      const deltaX = clientX - panState.startX;
      const deltaY = clientY - panState.startY;
      if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) panState.moved = true;
      if (!panState.moved) return;
      event?.preventDefault();
      zoomFrame.scrollLeft = panState.startLeft - deltaX;
      zoomFrame.scrollTop = panState.startTop - deltaY;
    };
    const endPan = () => {
      if (!panState) return;
      if (panState.moved) suppressZoomClick = true;
      zoomFrame.classList.remove('is-panning');
      panState = null;
    };
    zoomFrame?.addEventListener('mousedown', (event) => {
      if (event.button !== 0) return;
      startPan(event.clientX, event.clientY);
      event.preventDefault();
    });
    window.addEventListener('mousemove', (event) => movePan(event.clientX, event.clientY, event));
    window.addEventListener('mouseup', endPan);
    zoomFrame?.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      if (!touch) return;
      startPan(touch.clientX, touch.clientY);
    }, { passive: true });
    zoomFrame?.addEventListener('touchmove', (event) => {
      const touch = event.touches[0];
      if (!touch) return;
      movePan(touch.clientX, touch.clientY, event);
    }, { passive: false });
    zoomFrame?.addEventListener('touchend', endPan, { passive: true });
    zoomFrame?.addEventListener('touchcancel', endPan, { passive: true });
    zoomFrame?.addEventListener('wheel', (event) => {
      if (!zoomImage?.classList.contains('is-zoomed')) return;
      event.preventDefault();
      zoomFrame.scrollLeft += event.deltaX;
      zoomFrame.scrollTop += event.deltaY;
    }, { passive: false });
    zoomViewer?.querySelectorAll('[data-product-zoom-close]').forEach((control) => {
      control.addEventListener('click', closeZoom);
    });
    zoomViewer?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeZoom();
    });

    let touchStart = 0;

    previous?.addEventListener('click', () => show(index - 1));
    next?.addEventListener('click', () => show(index + 1));
    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });
    carousel.addEventListener('touchstart', (event) => {
      touchStart = event.changedTouches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(distance) < 45) return;
      show(index + (distance < 0 ? 1 : -1));
    }, { passive: true });

    if (hasColorSlides) {
      colorButtons.forEach((button) => {
        button.addEventListener('click', () => showColor(button.dataset.storyColor || ''));
      });
    }

    const initialColor = colorButtons.find((button) => button.getAttribute('aria-pressed') === 'true')?.dataset.storyColor;
    visibleSlides = matchingSlides(initialColor);
    show(0);
  });
}

function initCardSwatches() {
  document.querySelectorAll('[data-card-gallery]').forEach((card) => {
    const image = card.querySelector('[data-card-image]');
    const hoverImage = card.querySelector('[data-card-hover-image]');
    const swatches = Array.from(card.querySelectorAll('[data-card-swatch]'));
    if (!image || !swatches.length) return;

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const src = swatch.dataset.imageSrc;
        if (!src) return;
        image.src = src;
        image.alt = swatch.dataset.imageAlt || image.alt;
        if (hoverImage && swatch.dataset.imageHoverSrc) hoverImage.src = swatch.dataset.imageHoverSrc;
        swatches.forEach((item) => {
          const selected = item === swatch;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      });
    });
  });
}

function initProductStoryPurchase() {
  document.querySelectorAll('[data-story-product]').forEach((story) => {
    const form = story.querySelector('[data-story-product-form]');
    const variantSelect = story.querySelector('[data-story-variant-select]');
    const sizeSelect = story.querySelector('[data-story-size]');
    const colorButtons = Array.from(story.querySelectorAll('[data-story-color]'));
    const selectedColor = story.querySelector('[data-story-selected-color]');
    const heroImage = story.querySelector('[data-story-hero-image]');
    const status = story.querySelector('[data-story-cart-status]');
    const confirmation = story.querySelector('[data-cart-confirmation]');
    const confirmationCopy = confirmation?.querySelector('[data-cart-confirmation-copy]');
    const confirmationCheckout = confirmation?.querySelector('[data-cart-confirmation-checkout]');
    const title = story.dataset.storyTitle || 'Item';
    if (!variantSelect || !sizeSelect) return;

    let confirmationTrigger = null;
    const closeConfirmation = () => {
      if (!confirmation) return;
      confirmation.hidden = true;
      confirmation.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-confirmation-open');
      confirmationTrigger?.focus();
    };
    const openConfirmation = (trigger) => {
      if (!confirmation) return;
      confirmationTrigger = trigger;
      confirmation.hidden = false;
      confirmation.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-confirmation-open');
      confirmation.querySelector('.cart-confirmation-close')?.focus();
    };
    confirmation?.querySelectorAll('[data-cart-confirmation-close]').forEach((control) => {
      control.addEventListener('click', closeConfirmation);
    });
    confirmation?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeConfirmation();
    });

    const activeColor = () => colorButtons.find((button) => button.getAttribute('aria-pressed') === 'true');
    const syncVariant = () => {
      const size = sizeSelect.value;
      const color = activeColor()?.dataset.storyColor || '';
      const match = Array.from(variantSelect.options).find((option) =>
        option.dataset.storySize === size && option.dataset.storyColor === color && !option.disabled
      );
      if (match) variantSelect.value = match.value;
    };

    colorButtons.forEach((button) => {
      button.addEventListener('click', () => {
        colorButtons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('on', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        if (selectedColor) selectedColor.textContent = button.dataset.storyColor || '';
        const activeHeroImage = story.querySelector('.product-slide.is-active [data-story-hero-image]') || heroImage;
        if (activeHeroImage && button.dataset.storyImage) {
          activeHeroImage.src = button.dataset.storyImage;
          activeHeroImage.alt = `${title} in ${button.dataset.storyColor || ''}`;
        }
        syncVariant();
      });
    });
    sizeSelect.addEventListener('change', syncVariant);
    syncVariant();

    if (!form) return;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[data-story-add-to-cart]');
      if (button) { button.disabled = true; button.textContent = 'Adding'; }
      if (status) status.textContent = '';
      const embroideryConsent = form.querySelector('[data-embroidery-consent]');
      const embroideryConsentError = form.querySelector('[data-embroidery-consent-error]');
      if (form.querySelector('[data-embroidery-toggle]')?.checked && !embroideryConsent?.checked) {
        if (embroideryConsentError) embroideryConsentError.hidden = false;
        if (status) status.textContent = 'Please confirm the custom embroidery payment terms.';
        embroideryConsent?.focus();
        if (button) { button.disabled = false; button.textContent = `Add ${title} to bag`; }
        return;
      }
      try {
        const formData = new FormData(form);
        const quantity = Number.parseInt(formData.get('quantity'), 10) || 1;
        const baseProperties = {};
        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && String(value).trim()) baseProperties[match[1]] = String(value).trim();
        });
        const items = [{
          id: Number(formData.get('id')),
          quantity,
          ...(Object.keys(baseProperties).length ? { properties: baseProperties } : {})
        }];
        const embroideryToggle = form.querySelector('[data-embroidery-toggle]');
        const embroideryAddonId = Number(form.dataset.embroideryAddonId);
        if (embroideryToggle?.checked && embroideryAddonId) {
          const embroideryProperties = {
            'For product': title,
            'Embroidery text': formData.get('properties[Embroidery text]')?.toString().trim() || 'To be confirmed',
            'Placement': formData.get('properties[Embroidery placement]')?.toString().trim() || 'Right chest (recommended)',
            'Notes': formData.get('properties[Embroidery notes]')?.toString().trim() || 'None'
          };
          items.push({ id: embroideryAddonId, quantity, properties: embroideryProperties });
        }
        const customOrder = Boolean(embroideryToggle?.checked && embroideryAddonId);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Unable to add item');
        if (confirmationCheckout) {
          confirmationCheckout.href = customOrder ? '/cart' : '/checkout';
          confirmationCheckout.textContent = customOrder ? 'Review cart & payment details' : 'Go to checkout';
        }
        if (confirmationCopy) {
          confirmationCopy.textContent = customOrder
            ? 'Your custom order is in the bag. Review the bank-transfer instructions before checkout.'
            : 'Would you like to go to checkout now or continue shopping?';
        }
        if (status) status.textContent = `${title} added to your bag.`;
        openConfirmation(button);
      } catch (error) {
        if (status) status.textContent = 'Could not add this item. Please try again.';
      } finally {
        if (button) { button.disabled = false; button.textContent = `Add ${title} to bag`; }
      }
    });
  });
}

function initProductPurchase() {
  document.querySelectorAll('[data-product-embroidery-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const originalText = button?.textContent || 'Add to bag';
      if (button) { button.disabled = true; button.textContent = 'Adding'; }
      const embroideryToggle = form.querySelector('[data-product-embroidery-toggle]');
      const embroideryConsent = form.querySelector('[data-embroidery-consent]');
      const embroideryConsentError = form.querySelector('[data-embroidery-consent-error]');
      if (embroideryToggle?.checked && !embroideryConsent?.checked) {
        if (embroideryConsentError) embroideryConsentError.hidden = false;
        embroideryConsent?.focus();
        if (button) { button.disabled = false; button.textContent = originalText; }
        return;
      }
      const formData = new FormData(form);
      const quantity = Number.parseInt(formData.get('quantity'), 10) || 1;
      const baseProperties = {};
      formData.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim()) baseProperties[match[1]] = String(value).trim();
      });
      const items = [{
        id: Number(formData.get('id')),
        quantity,
        ...(Object.keys(baseProperties).length ? { properties: baseProperties } : {})
      }];
      const embroideryAddonId = Number(form.dataset.embroideryAddonId);
      if (embroideryToggle?.checked && embroideryAddonId) {
        items.push({
          id: embroideryAddonId,
          quantity,
          properties: {
            'For product': form.closest('.pdp')?.querySelector('.pdp-title')?.textContent.trim() || 'Product',
            'Embroidery text': formData.get('properties[Embroidery text]')?.toString().trim() || 'To be confirmed',
            'Placement': formData.get('properties[Embroidery placement]')?.toString().trim() || 'Right chest (recommended)',
            'Notes': formData.get('properties[Embroidery notes]')?.toString().trim() || 'None'
          }
        });
      }
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Unable to add item');
        window.location.href = '/cart';
      } catch (error) {
        if (button) { button.disabled = false; button.textContent = originalText; }
      }
    });
  });
}

function initReveals() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal').forEach((element) => element.classList.add('in'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('in');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach((element) => observer.observe(element));
}

document.addEventListener('DOMContentLoaded', async () => {
  initMobileNavigation();
  if (typeof window.pageInit === 'function') await window.pageInit();
  initProductCarousels();
  initCardSwatches();
  initProductStoryPurchase();
  initProductPurchase();
  initEmbroideryRequests();
  initProductEmbroidery();
  initCartQuantityControls();
  initBundleBuilder();
  initReveals();
});
